import { graphql, useStaticQuery } from 'gatsby';

import { AllDiseasesQuery } from '../../generated/types/gatsby';

export const useDiseases = () => {
  return useStaticQuery<AllDiseasesQuery>(graphql`
    query allDiseases {
      allDrupalContentDisease {
        nodes {
          title
          path
          id
          shortDescriptionHtml
        }
      }
    }
  `);
};
